
import React from "react";
import { Link } from "react-router-dom";
import "./Unauthorized.css";

const Unauthorized = () => {
  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        {/* <h1>403</h1> */}
        <h2>Access Denied</h2>
        <p>
          You are not authorized to access this page.
          Please contact your administrator if you believe this is an error.
        </p>

        <Link to="/" className="home-btn">
          Go to Home Page
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;